export default __webpack_public_path__ + "static/media/binocular.2d06dc10.svg";